import ApiResponse from "@/server/responses/ApiResponse";
import Duel from "@/server/structures/Duel";

export default class ApiResponse_GetDuel extends ApiResponse {

    get duel() {
        return new Duel(this._rawResponse.data);
    }
}
